import { render } from "./BuildTheSkillsCertificate.vue?vue&type=template&id=4245e119&scoped=true"
import script from "./BuildTheSkillsCertificate.vue?vue&type=script&lang=js"
export * from "./BuildTheSkillsCertificate.vue?vue&type=script&lang=js"

import "./BuildTheSkillsCertificate.vue?vue&type=style&index=0&id=4245e119&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4245e119"]])

export default __exports__